<template>
  <v-row dense>
    <v-col cols="12">
      <v-text-field required counter
        v-model="form.title"
        label="プログラム/学校名"
        maxlength="100"
        :rules="rules.title"
      />
    </v-col>
    <v-col cols="12">
      <v-select
        v-model="form.arranger"
        label="手配担当"
        item-text="name"
        item-value="userid"
        :items="getArrangerItems"
        :rules="rules.arranger"
      />
    </v-col>
    <v-col cols="12">
      <v-menu offset-y
        v-model="config.datepicker.start"
        transition="scale-transition"
        min-width="290px"
        :close-on-content-click="false"
        :nudge-right="40">
        <template v-slot:activator="{ on }">
          <v-text-field readonly
            v-model="printFormStart"
            v-on="on"
            label="出発日"
          />
        </template>
        <v-date-picker
          v-model="form.start"
          locale="ja"
          color="amber"
          :day-format="date => new Date(date).getUTCDate()"
          @input="config.datepicker.start = false"
        />
      </v-menu>
    </v-col>
    <v-col cols="12">
      <v-menu offset-y
        v-model="config.datepicker.end"
        transition="scale-transition"
        min-width="290px"
        :close-on-content-click="false"
        :nudge-right="40">
        <template v-slot:activator="{ on }">
          <v-text-field readonly
            v-model="printFormEnd"
            v-on="on"
            label="終了日"
          />
        </template>
        <v-date-picker
          v-model="form.end"
          locale="ja"
          color="amber"
          :day-format="date => new Date(date).getUTCDate()"
          @input="config.datepicker.end = false"
        />
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'cli-arranges-toolkit-edit',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false
        },
        datepicker: {
          start: false,
          end: false
        }
      },
      rules: {
        title: [
          v => !!v || '必須項目です'
        ],
        arranger: [
          v => !!v || '必須項目です'
        ]
      },
      form: {
        id: '',
        title: '',
        arranger: '',
        start: '',
        end: ''
      }
    }
  },
  methods: {
    update: function (req) {
      const { id, title, aid, start, end } = req || {}
      this.$set(this, 'form', {
        id,
        title: title || '',
        arranger: aid || '',
        start: start ? start.replace('0000-00-00', '') : '',
        end: end ? end.replace('0000-00-00', '') : ''
      })
    },
    getFormData: function () {
      return this.form
    }
  },
  computed: {
    printFormStart () {
      return (
        this.form &&
        this.form.start
      ) ? this.$moment(this.form.start).format('YYYY/MM/DD') : ''
    },
    printFormEnd () {
      return (
        this.form &&
        this.form.end
      ) ? this.$moment(this.form.end).format('YYYY/MM/DD') : ''
    },
    getArrangerItems () {
      let authors = this.$store.getters['config/get']('authors')
      return Object.keys(authors).filter(userid => {
        return authors[userid].roles.includes('consultant')
      }).map(userid => {
        return {
          userid,
          name: authors[userid].name[0]
        }
      })
    }
  }
}
</script>
